'use strict';

frontendApp.directive('iioThemePoweredBy', ['$rootScope', 'ThemeService', function ($rootScope, ThemeService) {

  return {
    restrict: 'A',
    scope: false,
    link: function (scope, element, attrs) {

      element.hide();

      scope.theme = ThemeService.getCurrentTheme();
      scope.$on(ThemeService.EVENTS.THEME_CHANGED, function (evt, theme) {
        scope.theme = theme;
      });

      scope.$watch('theme', function (val) {
        if (!_.isEmpty(val)) {
          console.log("PoweredBy: ", val);

          if (val["name"].includes("Indexed I/O - Big Data eDiscovery")) {
            element.hide();
          } else {
            element.show();
          }
        }
      });

    }
  }

}]);
